import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import ModalRoteirizacaoPrevia from './ModalRoteirizacaoPrevia'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  apagarRoteirizacoesPrevia,
  getRoteirizacoesPrevia,
} from '../../../../services/api/https/deliveries/roteirizacao-previa.http'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'

const { dataFinal, dataInicial } = getPeriodoMesAtual()

const RoteirizacaoPreviaDasEntregas = ({ history, selectedTp, dispatch }) => {
  // Constants
  const ROTEIRIZACAO_INITIAL = {
    name: '',
    qte_entregas: 0,
    peso: 0,
    status: 'Previa',
    tp_id: selectedTp,
  }
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')
  const [modal, setModal] = useState({ show: false, roteirizacao: ROTEIRIZACAO_INITIAL })
  const [roteirizacoes, setRoteirizacoes] = useState([])
  const [periodo, setPeriodo] = useState({ dataInicial, dataFinal })

  useEffect(() => {
    fetchRoteirizacoes()
  }, [periodo])

  // Events

  const onModalSaved = roteirizacao => {
    const index = roteirizacoes.findIndex(r => r.id === roteirizacao.id)
    if (index === -1) {
      setRoteirizacoes([...roteirizacoes, roteirizacao])
    } else {
      setRoteirizacoes(prev => {
        prev[index] = roteirizacao
        return [...prev]
      })
    }
    setModal({ show: false, roteirizacao: null })
  }
  const onModalError = error => {
    setModal({ show: false, roteirizacao: null })
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onBtnNovoClick = () => {
    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione o Operador Logístico desejado'))
    } else {
      setModal({ show: true, roteirizacao: { ...ROTEIRIZACAO_INITIAL } })
    }
  }

  const onDelete = async roteirizacao => {
    try {
      dispatch(showLoadingBox('Apagando Roteirização Prévia ...', 'Aguarde'))
      await apagarRoteirizacoesPrevia(roteirizacao)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onMenuItemClicked = async (menuItem, roteirizacao) => {
    switch (menuItem) {
      case 'Editar':
        setModal({ show: true, roteirizacao })
        break
      case 'Apagar':
        await onDelete(roteirizacao)
        await fetchRoteirizacoes()
        break
      case 'Assoc. Entregas':
        history.push('/main/entregas/roteirizacao-assoc-entregas', { roteirizacao })
        break
      case 'Roteirizar':
        history.push('/main/entregas/roteirizacao-roteirizar-entregas', { roteirizacao })
        break
      default:
        break
    }
  }
  // Helpers
  const fetchRoteirizacoes = async () => {
    try {
      if (selectedTp === 0) {
        dispatch(showMessageBox(null, 'Selecione o Operador Logístico desejado'))
      } else {
        dispatch(showLoadingBox('Carregando as Roteirizações ...', 'Aguarde'))
        const savedRoteirizacoes = await getRoteirizacoesPrevia(
          selectedTp,
          periodo.dataInicial,
          periodo.dataFinal,
        )
        setRoteirizacoes(savedRoteirizacoes)
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }
  // Render
  return (
    <>
      <PageHeader>3.12 - Roteirização Prévia das Entregas</PageHeader>
      <div style={{ marginTop: 25 }}>
        <CustomPanel showBtnNovo onVoltar={history.goBack} onNovo={onBtnNovoClick}>
          <div className="p-grid">
            <div className="p-col-12">
              <Periodo
                onPesquisar={(pInicial, pFinal) =>
                  setPeriodo({
                    dataInicial: pInicial,
                    dataFinal: pFinal,
                  })
                }
              />
            </div>
            <div className="p-col-12">
              <DataTable
                value={roteirizacoes}
                emptyMessage={'Nenhuma Roteirização Encontrada'}
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                paginator={true}
                rows={20}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered(90)} />
                <Column field={'name'} header={'Roteirização'} />
                <Column
                  field={'qte_entregas'}
                  header={'Qte Entregas'}
                  style={tableCellCentered(150)}
                />
                <Column field={'peso'} header={'Peso'} style={tableCellCentered(90)} />
                <Column field={'status'} header={'Status'} style={tableCellCentered(150)} />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={roteirizacao => (
                    <ThreeDots
                      items={['Editar', 'Apagar', 'Assoc. Entregas', 'Roteirizar']}
                      onClick={item => onMenuItemClicked(item, roteirizacao)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalRoteirizacaoPrevia
        show={modal.show}
        roteirizacao={modal.roteirizacao}
        onResponse={(action, payload) => {
          action === 'close' && setModal({ show: false, roteirizacao: null })
          action === 'success' && onModalSaved(payload)
          action === 'error' && onModalError(payload)
        }}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RoteirizacaoPreviaDasEntregas))
